export default "skymp5-front/e8367608a7f9b2be450bf53cbdee2f41.png";